"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
function CommonDialog(props) {
    const { modalState, title, children, actions, ...dialogProps } = props;
    return ((0, jsx_runtime_1.jsxs)(material_1.Dialog, { onClose: () => {
            modalState.closeModal();
        }, ...dialogProps, open: modalState.modalIsOpen, children: [(0, jsx_runtime_1.jsx)(material_1.DialogTitle, { children: title }), (0, jsx_runtime_1.jsx)(material_1.DialogContent, { children: children }), (0, jsx_runtime_1.jsx)(material_1.DialogActions, { children: actions })] }));
}
exports.CommonDialog = CommonDialog;
//# sourceMappingURL=Dialog.js.map